<template>
  <div>
    <b-nav-item-dropdown
      class="dropdown-notification mr-25"
      menu-class="dropdown-menu-media"
      right
    >
      <template #button-content>
        <feather-icon
          :badge="G_NOTIFICATIONS_COUNT >= 99 ? '99+' : G_NOTIFICATIONS_COUNT"
          badge-classes="bg-danger"
          class="text-body"
          icon="BellIcon"
          size="21"
        />
      </template>

      <!-- Header -->
      <li class="dropdown-menu-header">
        <div class="dropdown-header d-flex">
          <h4 class="notification-title mb-0 mr-auto">
            {{ $t("Notifications") }}
          </h4>
          <b-badge pill variant="light-primary">
            {{ G_NOTIFICATIONS.length }}
          </b-badge>
        </div>
      </li>

      <!-- Notifications -->
      <vue-perfect-scrollbar
        :settings="perfectScrollbarSettings"
        class="scrollable-container media-list scroll-area"
        tagname="li"
      >
        <!-- Account Notification -->
        <template v-for="(notification, index) in G_NOTIFICATIONS">
          <b-link :key="index" class="p-0">
            <b-media class="py-0">
              <template #aside>
                <div class="d-flex align-items-center" style="height: 65px">
                  <b-avatar
                    size="39"
                    :src="notification.image"
                    :text="notification.title"
                    :variant="notification.type"
                  />
                </div>
              </template>
              <span
                class="font-weight-bolder text-info p-0"
                style="font-size: 13px"
              >
                {{ $t(notification.title) }}
              </span>
              <br />
              <span class="text-primary p-0" style="font-size: 12px">
                {{ notification.user_name }} </span
              ><br />
              <small
                :class="isDarkSkin ? 'text-dark' : 'text-light'"
                style="opacity: 0.7"
                >{{ notification.subtitle }}</small
              >
            </b-media>
          </b-link>
        </template>

        <!-- System Notification Toggler -->
        <!-- <div class="media d-flex align-items-center">
        <h6 class="font-weight-bolder mr-auto mb-0">System Notifications</h6>
        <b-form-checkbox :checked="true" switch />
      </div> -->

        <!-- System Notifications -->
        <!-- <b-link
        v-for="notification in systemNotifications"
        :key="notification.subtitle"
      >
        <b-media>
          <template #aside>
            <b-avatar size="32" :variant="notification.type">
              <feather-icon :icon="notification.icon" />
            </b-avatar>
          </template>
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{ notification.title }}
            </span>
          </p>
          <small class="notification-text">{{ notification.subtitle }}</small>
        </b-media>
      </b-link> -->
      </vue-perfect-scrollbar>

      <!-- Cart Footer -->
      <li class="dropdown-menu-footer">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="openAllNotificationModal"
          block
          >{{ $t("Read all notifications") }}</b-button
        >
      </li>
    </b-nav-item-dropdown>

    <AllNotificationsModal
      v-if="showAllNotificationModal"
      @close="closeAllNotificationModal"
    />
  </div>
</template>

<script>
import AllNotificationsModal from "@/@core/layouts/components/app-navbar/components/AllNotificationsModal.vue";
import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BLink,
  BAvatar,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Ripple from "vue-ripple-directive";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
    AllNotificationsModal,
  },
  directives: {
    Ripple,
  },
  computed: {
    ...mapGetters({
      G_NOTIFICATIONS: "NotificationStore/G_NOTIFICATIONS",
      G_NOTIFICATIONS_COUNT: "NotificationStore/G_NOTIFICATIONS_COUNT",
    }),
  },
  methods: {
    ...mapActions({
      A_GET_NOTIFICATIONS: "NotificationStore/A_GET_NOTIFICATIONS",
    }),
    openAllNotificationModal() {
      this.showAllNotificationModal = true;
    },
    closeAllNotificationModal() {
      this.showAllNotificationModal = false;
    },
  },
  async created() {
    await this.A_GET_NOTIFICATIONS();
  },
  data() {
    return {
      showAllNotificationModal: false,
    };
  },
  setup() {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };

    return {
      perfectScrollbarSettings,
    };
  },
};
</script>

<style>
</style>
